<template>
  <section class="xpress-documentation-section">
    <article class="document-content">
      <section class="heading-container">
        <h1 class="caption">Get Batch Transaction By Batch Number</h1>
        <p>
          This endpoint gets batch transaction by <strong>batch number</strong>.
        </p>
        <p><span class="fw-bold">Method: </span>GET</p>
        <p><span class="fw-bold">Header: </span>AccessToken</p>
        <p>
          <span class="fw-bold">Url: </span><span class="api-url">/api/v1/FundDisbursement/GetXPBulkByBatchNo</span>
        </p>
        <p>Parameter: batchNo</p>
      </section>
      <!-- ------------------------- -->
      <section class="sub-heading-container">
        <h5 class="sub-caption">Sample Response</h5>
      </section>
      <!-- ------------------------- -->
      <section class="xpress-doc-code-bg">
        <div class="request-response-container">
          <code class="main-brace">{</code>
          <!-- ------ -->
          <code class="key-value-pair">
            <li>
              <span class="obj-key">"responseCode"</span>:&nbsp;
              <span class="obj-value">"00"</span>,
            </li>
            <li>
              <span class="obj-key">"responseMessage"</span>:&nbsp;
              <span class="obj-value">"Ok"</span>,
            </li>
            <li>
              <span class="obj-key">"data"</span>:&nbsp;
              <span class="obj-value-brace">{</span>
            </li>

            <!-- inner object value-------- -->
            <li>
              <div class="inner-key-value-pair">
                <span class="obj-key">"batchstatus"</span>:&nbsp;
                <span class="obj-value-brace">{</span>
              </div>

              <!-- inner object-------- -->
                <div class="inner-key-value-pair">
                  <div class="inner-key-value-pair">
                    <span class="obj-key">"batchStatus"</span>:&nbsp;
                    <span class="obj-value">"batchStatus"</span>,
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-key">"channel"</span>:&nbsp;
                    <span class="obj-value">"API"</span>,
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-key">"debitAccount"</span>:&nbsp;
                    <span class="obj-value">"0049648066"</span>,
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-key">"transactionCount"</span>:&nbsp;
                    <span class="obj-value num">0</span>,
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-key">"isApproved"</span>:&nbsp;
                    <span class="obj-value bool">true</span>,
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-key">"batchNumber"</span>:&nbsp;
                    <span class="obj-value">"89849389893893849"</span>,
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-key">"batchReference"</span>:&nbsp;
                    <span class="obj-value">"hel3059103992021"</span>
                  </div>
                </div>
                <div class="inner-key-value-pair">
                  <span class="obj-value-brace">}</span>,
                </div>
              </li>
              <!-- -------------------------- -->
              <li>
                <div class="inner-key-value-pair">
                  <span class="obj-key">"batchTransactions"</span>:&nbsp;
                  <span class="obj-value-brace">[</span>
                </div>
                <!-- inner object-------- -->
                <div class="inner-key-value-pair">
                  <div class="inner-key-value-pair">
                    <span class="obj-value-brace">{</span>
                  </div>
                  <div class="inner-key-value-pair">
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryAccount"</span>:&nbsp;
                      <span class="obj-value">"2076646137"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryName"</span>:&nbsp;
                      <span class="obj-value">"Ajibola Fasasi"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"bankName"</span>:&nbsp;
                      <span class="obj-value">"UBA"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryBankCode"</span>:&nbsp;
                      <span class="obj-value">"033"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionAmount"</span>:&nbsp;
                      <span class="obj-value num">200.00</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"narration"</span>:&nbsp;
                      <span class="obj-value">"Xpress Payment of Jan Salary"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionReference"</span>:&nbsp;
                      <span class="obj-value null">null</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionNumber"</span>:&nbsp;
                      <span class="obj-value">"0982925929291029"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"isProcessed"</span>:&nbsp;
                      <span class="obj-value bool">false</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"isSuccessful"</span>:&nbsp;
                      <span class="obj-value bool">false</span>,
                    </div>
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-value-brace">}</span>
                  </div>
                </div>
                <!-- -------------------------- -->
                <div class="inner-key-value-pair">
                  <span class="obj-value-brace">]</span>,
                </div>
              </li>
              <li>
                <div class="inner-key-value-pair">
                  <span class="obj-key">"failedAVSTransactions"</span>:&nbsp;
                  <span class="obj-value-brace">[</span>
                </div>

                <!-- inner object-------- -->
                <div class="inner-key-value-pair">
                  <div class="inner-key-value-pair">
                    <span class="obj-value-brace">{</span>
                  </div>
                  <div class="inner-key-value-pair">
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryAccount"</span>:&nbsp;
                      <span class="obj-value">"2076646137"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryName"</span>:&nbsp;
                      <span class="obj-value">"Ajibola Fasasi"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"bankName"</span>:&nbsp;
                      <span class="obj-value">"UBA"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryBankCode"</span>:&nbsp;
                      <span class="obj-value">"033"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionAmount"</span>:&nbsp;
                      <span class="obj-value num">200.00</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"narration"</span>:&nbsp;
                      <span class="obj-value">"Xpress Payment of Jan Salary"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionReference"</span>:&nbsp;
                      <span class="obj-value null">null</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionNumber"</span>:&nbsp;
                      <span class="obj-value">"0982925929291029"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"isProcessed"</span>:&nbsp;
                      <span class="obj-value bool">false</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"isSuccessful"</span>:&nbsp;
                      <span class="obj-value bool">false</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"verificationError"</span>:&nbsp;
                      <span class="obj-value null">null</span>
                    </div>
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-value-brace">}</span>
                  </div>
                </div>
                <!-- -------------------------- -->
                <div class="inner-key-value-pair">
                  <span class="obj-value-brace">]</span>,
                </div>
              </li>
              <li>
                <div class="inner-key-value-pair">
                  <span class="obj-key">"yetToProcessBatchTransactions"</span>:&nbsp;
                  <span class="obj-value-brace">[</span>
                </div>

                <!-- inner object-------- -->
                <div class="inner-key-value-pair">
                  <div class="inner-key-value-pair">
                    <span class="obj-value-brace">{</span>
                  </div>
                  <div class="inner-key-value-pair">
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryAccount"</span>:&nbsp;
                      <span class="obj-value">"2076646137"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryName"</span>:&nbsp;
                      <span class="obj-value">"Ajibola Fasasi"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"bankName"</span>:&nbsp;
                      <span class="obj-value">"UBA"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"beneficiaryBankCode"</span>:&nbsp;
                      <span class="obj-value">"033"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionAmount"</span>:&nbsp;
                      <span class="obj-value num">200.00</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"narration"</span>:&nbsp;
                      <span class="obj-value">"Xpress Payment of Jan Salary"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionReference"</span>:&nbsp;
                      <span class="obj-value null">null</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"transactionNumber"</span>:&nbsp;
                      <span class="obj-value">"0982925929291029"</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"isProcessed"</span>:&nbsp;
                      <span class="obj-value bool">false</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"isSuccessful"</span>:&nbsp;
                      <span class="obj-value bool">false</span>,
                    </div>
                    <div class="inner-key-value-pair">
                      <span class="obj-key">"verificationError"</span>:&nbsp;
                      <span class="obj-value null">null</span>
                    </div>
                  </div>
                  <div class="inner-key-value-pair">
                    <span class="obj-value-brace">}</span>
                  </div>
                </div>
                <!-- -------------------------- -->
                <div class="inner-key-value-pair">
                  <span class="obj-value-brace">]</span>
                </div>
              </li>
            </code>
          <!-- ------ -->
          <code class="main-brace">}</code>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
export default {
  name: 'Get Batch Transaction'
}
</script>
